// extracted by mini-css-extract-plugin
export const toolTip = "pricing-plans-module--toolTip--30hTT";
export const toolTipSmall = "pricing-plans-module--toolTipSmall--EvRDB";